var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { FiltersSearch } from './filters-search';
import { SearchType, ListingCategory } from '../../../classes/enums';
import { take } from 'rxjs/operators';
var FiltersSearchMobileComponent = /** @class */ (function (_super) {
    __extends(FiltersSearchMobileComponent, _super);
    function FiltersSearchMobileComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FiltersSearchMobileComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.formDebounceTimeInMs = 500;
        this.addSub(this.onFiltersChange.subscribe(function (filters) {
            _this.communicationService.filters.search.next(filters);
        }));
        this.addSub(this.communicationService.filters.totalHits.subscribe(function (totalHits) {
            document.querySelector('app-drawer .drawer-sub-title-right').innerHTML = _this.translateService.instant('filters.n-results', { n: totalHits });
        }));
        this.listenToFormChanges();
    };
    /**
     */
    FiltersSearchMobileComponent.prototype.fetchFilters = function () {
        var _this = this;
        (this.searchType === SearchType.AGENT ?
            this.preferencesService.agentSearchFiltersChanged :
            this.preferencesService.officeSearchFiltersChanged).pipe(take(1)).toPromise().then(function (filters) {
            if (_this.currentShownListingType === ListingCategory.COMMERCIAL) {
                _this._updateRealEstateFilterForPropertyType(filters, 'Commercial');
            }
            _this.updateFilters(filters);
        });
    };
    return FiltersSearchMobileComponent;
}(FiltersSearch));
export { FiltersSearchMobileComponent };
